const simName = location.host.split('.')[0]
const devGetWayProp = 'online' // 用来切换环境 比如pre 写pre
const devSimName = 'sim271'

// 支付的基准是000，最小集从200开始，外卖则060是基准，从100开始，所以动态匹配时如果是<200的环境都匹配000，其他正常动态匹配
let paySim = Number(simName.replace('sim', ''))
if (isNaN(paySim)) paySim = 'sim000'
else paySim = paySim < 200 ? 'sim000' : `sim${paySim}`

const GetWay = {
  dev: {
    env: 'dev',
    cApiBase: `http://${devSimName}.rlab.sim.intra.xiaojukeji.com/c-api`,
    cashierApiBase: `https://d${devSimName}-api.intra.xiaojukeji.com`,
    payApiBase: `https://d${devSimName}-api.intra.xiaojukeji.com`,
  },
  test: {
    env: 'test',
    cApiBase: 'https://c.didi-food.com',
    cashierApiBase: 'https://cashier.didiglobal.com',
    payApiBase: 'https://pay.didiglobal.com',
  },
  pre: {
    env: 'pre',
    cApiBase: 'https://pre-c.didi-food.com',
    cashierApiBase: 'https://cashier-pre.didiglobal.com',
    payApiBase: 'https://pay-pre.didiglobal.com',
  },
  online: {
    env: 'online',
    cApiBase: 'https://c.didi-food.com',
    cashierApiBase: 'https://cashier.didiglobal.com',
    payApiBase: 'https://pay.didiglobal.com',
  },
  sim: {
    env: 'sim',
    cApiBase: `http://${simName}.rlab.sim.intra.xiaojukeji.com/c-api`,
    cashierApiBase: `https://d${paySim}-api.intra.xiaojukeji.com`,
    payApiBase: `https://d${paySim}-api.intra.xiaojukeji.com`,
  },
}
GetWay.dev = GetWay[devGetWayProp || 'dev']
export default GetWay
